// extracted by mini-css-extract-plugin
export default {"openBoxes":"HomePage_openBoxes__GGGzf","contactInputs":"HomePage_contactInputs__MpLdQ","iframe":"HomePage_iframe__-MAB0"};